<script>

import Multiselect from 'vue-multiselect'
import { periodicTasksCrontabScheduleMethods } from '@state/helpers'
import { required } from 'vuelidate/lib/validators'
import CrontabScheduleForm from "@components/scheduled-tasks/crontab-schedule/form";
import CrontabScheduleDelete from "@components/scheduled-tasks/crontab-schedule/delete";


export default {
  name: 'CrontabScheduleSelector',
  components: {Multiselect , CrontabScheduleForm, CrontabScheduleDelete},
  props: {
    value: {
      required: false,
      default: ()=>(''),
    },
  },
  data() {
    return {
      loading: false,
      showForm: false,
      showDelete: false,
      toUpdate: {},
      toDelete: {},
      periodicTasksCrontabScheduleOptions: [],
      loadingPeriodicTasksCrontabScheduleOptions: false,
      periodicTasksCrontabScheduleOptionsMounted: true,
      periodicTasksCrontabScheduleOptionsCache: []
    }
  },
  computed: {
    inputVal: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      }
    }
  },

  mounted: function () {
    let context = this
    context.populatePeriodicTasksCrontabScheduleOptions()
  },

  methods: {
    ...periodicTasksCrontabScheduleMethods,

    populatePeriodicTasksCrontabScheduleOptions(searchQuery){
      let context = this
      context.loadingPeriodicTasksCrontabScheduleOptions = true
      let reqParams = context.$select_params(searchQuery)
      // reqParams = `${reqParams}${!reqParams ? '?' : '&'}customer=${context.form.customer}`
      const promise = context.fetchPeriodicTasksCrontabSchedule(reqParams)
      return promise.then(data => {
          let listOptions = []
          data.results.forEach(opt => {
              listOptions.push({
                  'url': opt.url,
                  'name': opt.name
              })
          });
          context.periodicTasksCrontabScheduleOptions = listOptions
          context.loadingPeriodicTasksCrontabScheduleOptions = false
          context.periodicTasksCrontabScheduleOptionsMounted = true
      }).catch(error => {
          context.$axios_error_noty(error, context)
          context.loadingPeriodicTasksCrontabScheduleOptions = false
          context.periodicTasksCrontabScheduleOptionsMounted = true
      })
    },

    asyncFindPeriodicTasksCrontabSchedule: _.debounce(function (searchQuery) {
        this.populatePeriodicTasksCrontabScheduleOptions(searchQuery)
    }, 600),

    labelOfPeriodicTasksCrontabSchedule(opt){
      let context = this
      let optionFound = context.periodicTasksCrontabScheduleOptions.find(x => x.url === opt)
      if (!optionFound){
          let cacheFound = context.periodicTasksCrontabScheduleOptionsCache.find(x => x.url === opt)
          return  cacheFound ? cacheFound.name : context.periodicTasksCrontabScheduleOptionsMounted ? `No encontrado en las opciones: ${opt}`: ''
      }else{
          if (context.inputVal === opt){
              if (!context.periodicTasksCrontabScheduleOptionsCache.find(x => x.url === opt)){
                  context.periodicTasksCrontabScheduleOptionsCache.push(optionFound)
              }
          } 
          return optionFound.name
      }
    },
    
  },
}
</script>

<template>
  <b-container class="p-0">
    <b-row v-if="loading">
      <b-col md="12">
        <div class="text-center">
          <b-spinner
            label="Spinning"
            style="color: #195db2; width: 4rem; height: 4rem"
          ></b-spinner>
        </div>
      </b-col>
    </b-row>
    <b-form-group v-else label="Seleccionar crontab">
      <b-row>
        <b-col md="9">
          <Multiselect
              id="crontab-schedule-select"
              v-model="inputVal"
              :multiple="false"
              :options="periodicTasksCrontabScheduleOptions.map(x => x.url)" 
              :custom-label="opt => labelOfPeriodicTasksCrontabSchedule(opt)"
              :loading="loadingPeriodicTasksCrontabScheduleOptions"
              :internal-search="false"
              @search-change="asyncFindPeriodicTasksCrontabSchedule">
          </Multiselect>
        </b-col>
        <b-col md="3" class="justify-content-center align-self-center">
          <b-button-group size="xs">
            <b-button
              variant="primary"
              size="xs"
              :disabled="showForm || showDelete ? true : false"
              @click="()=>{showForm=true; toUpdate={}}">
              <i class="fe-plus"></i>
            </b-button>  
            <b-button
              v-if="inputVal"
              variant="warning"
              size="xs"
              :disabled="showForm || showDelete ? true : false"
              @click="()=>{showForm=true; toUpdate={url:inputVal}}">
              <i class="fe-edit"></i>
            </b-button>    
            <!-- <b-button
              v-if="inputVal"
              variant="danger"
              size="xs"
              :disabled="showForm || showDelete ? true : false"
              @click="()=>{showDelete=true; toDelete={url:inputVal}}">
              <i class="fe-x"></i>
            </b-button> -->
          </b-button-group>
        </b-col>
      </b-row>
    </b-form-group>

    <CrontabScheduleForm 
      v-if="showForm"
      :instanceJson="toUpdate || {}"
      :oncomplete="(selectedObj)=>{
        showForm=false;
        toUpdate={};
        populatePeriodicTasksCrontabScheduleOptions(); inputVal = selectedObj}"
      :oncancel="()=>{
        showForm=false;
        toUpdate={}}">
    </CrontabScheduleForm>

    <CrontabScheduleDelete 
      v-if="showDelete"
      :instanceJson="toDelete || {}"
      :oncomplete="(selectedObj)=>{
        showDelete=false;
        toDelete={};
        inputVal=null;
        populatePeriodicTasksCrontabScheduleOptions()}"
      :oncancel="()=>{
        showDelete=false;
        toDelete={};
        populatePeriodicTasksCrontabScheduleOptions()}">
    </CrontabScheduleDelete>

  </b-container>
</template>
<style lang="scss">
</style>